import React, {Component} from 'react';
import {Form, Input, Button, Select, Checkbox, Tooltip, Icon, Radio} from 'antd';
import request from "superagent";
import ConfirmModal from "../policy/component/ConfirmModal";

import {hashCode, openNotification, NotificationType, PermissionCtrl, getUrl} from "../../commons/CommonUtils";
import Constants, {NameColors, UserRole, LangOptions, Permissions} from "../../commons/Constants";

const FormItem = Form.Item;
const CheckboxGroup = Checkbox.Group;
const RadioGroup = Radio.Group;
const Option = Select.Option;

const formItemLayout = {
    labelCol: {
        xs: {span: 24},
        sm: {span: 6}
    },
    wrapperCol: {
        xs: {span: 24},
        sm: {span: 18}
    }
};
const emailRegExp = /^[a-zA-Z0-9]+([._\\-]*[a-zA-Z0-9])*@([a-zA-Z0-9]+[-a-zA-Z0-9]*[a-zA-Z0-9]+.){1,63}[a-zA-Z0-9]+$/;

const NameFormat = ({user, editMode, ...props}) => {
    if (!user || !editMode) {
        return (
            <div>
                <i className='page-detail-graphic graphic-user'></i>

                <div className='page-detail-info'>
                    <b>User Configuration</b>
                </div>
            </div>);
    } else {
        const userTitle = (user.fname.charAt(0) + user.lname.charAt(0)).toUpperCase();
        const i = Math.abs(hashCode(user.lname + user.fname) % 5);
        let nowColor = NameColors[i];

        return (
            <b>
                <div className="avatar-circle-sml"
                     style={{
                         float: "left",
                         color: nowColor,
                         backgroundColor: nowColor,
                         marginLeft: 20,
                         marginRight: 14
                     }}>
                    <div className="intials">{userTitle}</div>
                </div>
                <div style={{display: "inline-block", color: nowColor}}>
                    <div className="userName">{user.fname} {user.lname}</div>
                    <div className="userEmail">{user.email}</div>
                </div>
            </b>
        );
    }
}

class UserDetailInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showModel: false,
            status: ""
        };
        this.loginName = sessionStorage.getItem('username');
    }

    doAddOrEdit = (userInfo) => {
        const {refreshUserProfile, user, close} = this.props;

        this.setState({status: Constants.STATUS.trying});
        if (this.props.editMode) {
            this.activeConfirmModal.close();
            this.deactiveConfirmModal.close();
            //update
            const url = getUrl(Constants.Service.localUser, "/user/" + this.props.user.id);
            return request.patch(url)
                .withCredentials()
                .send(userInfo)
                .end((err, response) => {
                    if (err) {
                        this.setState({
                            status: Constants.STATUS.error,
                            message: "Fail to save user. Cause by: " + err.message
                        });
                        openNotification("Fail to save user. Cause by: " + err.message, NotificationType.error);
                    } else {
                        if (refreshUserProfile) {
                            refreshUserProfile(user.email);
                        }
                        close(true);
                        openNotification("Succeed to save user.", NotificationType.success);
                    }
                });
        } else {
            //add
            const url = getUrl(Constants.Service.localUser, "/user");
            return request.post(url)
                .withCredentials()
                .send(userInfo)
                .end((err, response) => {
                    if (err) {
                        this.setState({
                            status: Constants.STATUS.error,
                            message: "Fail to save user. Cause by: " + err.message
                        });
                        openNotification("Fail to save user. Cause by: " + err.message, NotificationType.error);
                    } else {
                        close(true);
                        openNotification("Succeed to save user.", NotificationType.success);
                    }
                });
        }
    }

    save = (event) => {
        event.preventDefault();

        this.props.form.validateFieldsAndScroll((err, userFormValue) => {
            if (!err) {
                // disable activate and deactivate temporarily
                if (this.props.editMode && (userFormValue.allowEnterpriseOnly !== this.props.user.allowEnterpriseOnly)) {
                    const activeDom = userFormValue.allowEnterpriseOnly ? this.deactiveConfirmModal : this.activeConfirmModal;
                    activeDom.open();
                } else {
                    this.doAddOrEdit(userFormValue);
                }
            }
        });
    }

    deleteUser = () => {
        this.deleteConfirmModal.close();
        this.setState({status: Constants.STATUS.deleting});
        const deleteUrl = getUrl(Constants.Service.localUser, '/user/' + this.props.user.id);
        request.delete(deleteUrl)
            .set('Content-Type', 'application/json')
            .withCredentials().send({})
            .end((error, response) => {
                if (!error) {
                    this.props.close(true);
                    openNotification("Succeed to delete user " + this.props.user.email + ".", NotificationType.success);
                } else {
                    console.error("Failed to delete user", error);
                    openNotification("Fail to delete user. Cause by: " + error.message, NotificationType.error);
                    this.setState({status: Constants.STATUS.error});
                }
            });
    }


    render() {
        const {status, message} = this.state;
        const {user, editMode} = this.props;
        const {getFieldDecorator, getFieldsValue} = this.props.form;
        const formValues = getFieldsValue();


        return (
            <div className="page-tenant-detail">
                <div className="page-close" onClick={() => this.props.close(false)}>
                    <span className="glyphicon glyphicon-chevron-right" aria-hidden="true"></span>
                </div>
                <div className='page-detail-title'>
                    <NameFormat user={user} editMode={editMode}/>
                </div>
                <div className="form-horizontal"
                     style={{paddingLeft: "30px", paddingRight: "30px", "maxWidth": "800px"}}>
                    <Form className="ant-form-horizontal">
                        {(status === Constants.STATUS.error || status === Constants.STATUS.done) &&
                        <div>
                            <div
                                className={status === Constants.STATUS.error ? "alert alert-dismissible alert-danger" : "alert alert-dismissible alert-info"}>
                                <strong>{message}</strong>
                            </div>
                        </div>
                        }

                        <FormItem {...formItemLayout} label="First Name">
                            {getFieldDecorator('fname', {
                                initialValue: user.fname,
                                rules: [{
                                    required: true,
                                    message: "Please input the first name. No more than 64 characters"
                                }, {max: 64}, {
                                    pattern: /^[a-zA-Z0-9!"#$%&'()*+,./:;<=>?@[\] ^_`{|}~-]*$/,
                                    message: "Only English chars are allowed."
                                }]
                            })(
                                <Input/>
                            )}
                        </FormItem>

                        <FormItem {...formItemLayout} label="Last Name">
                            {getFieldDecorator('lname', {
                                initialValue: user.lname,
                                rules: [{
                                    required: true,
                                    message: "Please input the first name. No more than 64 characters"
                                }, {max: 64}, {
                                    pattern: /^[a-zA-Z0-9!"#$%&'()*+,./:;<=>?@[\] ^_`{|}~-]*$/,
                                    message: "Only English chars are allowed."
                                }]
                            })(
                                <Input/>
                            )}
                        </FormItem>

                        {!editMode && (
                            <FormItem {...formItemLayout} label="Email Address">
                                {getFieldDecorator('email', {
                                    rules: [{
                                        required: true,
                                        pattern: emailRegExp,
                                        message: "Please input a valid email address."
                                    }]
                                })(
                                    <Input/>
                                )}
                            </FormItem>
                        )}

                        <FormItem {...formItemLayout} label="User Role">
                            {getFieldDecorator('roles', {
                                initialValue: user.roles,
                                rules: [{required: true, message: "Please select one role at least."}, {type: "array"}]
                            })(
                                <CheckboxGroup options={Object.keys(UserRole).map((role) => {return UserRole[role]})}/>
                            )}
                        </FormItem>

                        <FormItem {...formItemLayout} label="Sign In Account">
                            {getFieldDecorator('allowEnterpriseOnly', {
                                initialValue: !!user.allowEnterpriseOnly,
                                rules: [{required: true, message: "Please select account type."}]
                            })(
                                <RadioGroup name="providers">
                                    <Radio value={false}>Enterprise and Local</Radio>
                                    <Radio value={true}>Enterprise Only</Radio>
                                </RadioGroup>
                            )}
                        </FormItem>

                        <FormItem {...formItemLayout}
                            extra="This setting is only used for email notifications."
                            label="User Language">
                            {getFieldDecorator('locale', {
                                initialValue: user.locale,
                                rules: [{required: true, message: 'Please select one language!'}]
                            })(
                                <Select placeholder="Choose one language.">
                                    {
                                        Object.keys(LangOptions).map((lang) => {
                                            const data = LangOptions[lang];
                                            return <Option key={lang} value={data.value}>{data.label}</Option>
                                        })
                                    }
                                </Select>
                            )}
                        </FormItem>

                        <div className="ant-modal-footer" style={{paddingLeft: 0, paddingRight: 0}}>
                            <div className="col-lg-8" style={{textAlign: 'left', padding: 0}}>
                                <PermissionCtrl permission={[Permissions.User.EDIT]}>
                                    <Button type="primary" size="large" onClick={this.save}
                                            loading={status === Constants.STATUS.trying}
                                            disabled={status === Constants.STATUS.deleting}>
                                        {status === Constants.STATUS.trying ? "Saving" : "Save"}
                                    </Button>
                                </PermissionCtrl>
                                <Button size="large" onClick={() => this.props.close(false)}
                                        disabled={status === Constants.STATUS.trying || status === Constants.STATUS.deleting}>
                                    Cancel
                                </Button>

                            </div>
                            {(editMode && this.loginName !== user.email) &&
                            <PermissionCtrl permission={[Permissions.User.DELETE]}>
                                <div className="col-lg-4" style={{padding: 0}}>
                                    <Button type="danger" size="large" onClick={() => {
                                                    this.deleteConfirmModal.open();
                                                }}
                                            disabled={status === Constants.STATUS.trying}
                                            loading={status === Constants.STATUS.deleting}>
                                        Delete
                                    </Button>
                                </div>
                            </PermissionCtrl>
                            }
                        </div>
                    </Form>
                </div>

                <ConfirmModal ref={(confirm) => {this.deactiveConfirmModal = confirm}}
                              callback={() => this.doAddOrEdit(formValues)}
                              title="Deactivate User"
                              body={"Are you sure you want to deactivate the local account of user " + user.email + " ?"}
                              isConfirm="true"/>

                <ConfirmModal ref={(confirm) => {this.activeConfirmModal = confirm}}
                              callback={() => this.doAddOrEdit(formValues)}
                              title="Activate User"
                              body={"Are you sure you want to activate the local account of user " + user.email + " ?"}
                              isConfirm="true"/>

                <ConfirmModal ref={(confirm) => {this.deleteConfirmModal = confirm}}
                              callback={() => this.deleteUser()}
                              title="Delete User"
                              body={"Are you sure you want to delete user " + user.email + " ?"}
                              isConfirm="true" isDelete="true"/>

            </div>
        );
    }
}

class UserDetailInfoWrapper extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showModel: false,
            editMode: false
        };
    }

    getUserByID = (id, callback) => {
        console.log("get policy:" + id);
        const userID = id ? id : this.props.userID;

        if (userID) {
            const url = getUrl(Constants.Service.localUser, "/user/" + userID);
            //'/api/user/' + userID
            request.get(url).withCredentials()
                .end((err, res) => {
                    if (err) {
                        openNotification("Fail to get [" + userID + "]. Cause by: " + err.message, NotificationType.error);
                    } else {
                        let result = res.body;
                        result.roles = result.roles.filter((role) => Object.keys(UserRole).indexOf(role) >= 0);
                        this.setState({data: result, editMode: true});
                        if (callback)
                            callback();
                    }
                })
        } else
            this.setState({data: this.getInitData(), editMode: false},
                () => {
                    if (callback)
                        callback();
                });
    }

    getInitData = () => {
        const allUserRoleList = Object.keys(UserRole).map((role) => {
            return UserRole[role]["value"];
        })
        return {
            fname: "", lname: "", email: "",
            allowEnterpriseOnly: true,
            roles: allUserRoleList,
            locale: LangOptions["en-US"]["value"]
        };
    }

    open = (userID) => {
        this.getUserByID(userID, () => {
            this.setState({showModel: true});
        });
    }

    close = (fresh) => {
        this.setState({data: this.getInitData(), showModel: false}, () => {
            this.props.close(fresh);
        });
    }

    render() {
        const {showModel, editMode, data} = this.state;
        const {close, ...props} = this.props;

        if (!showModel)
            return null;

        const UserDetail = Form.create()(UserDetailInfo);
        return <UserDetail close={this.close} {...props} user={data} editMode={editMode}/>;
    }
}


export default UserDetailInfoWrapper;



// WEBPACK FOOTER //
// ./src/modules/user/UserDetailInfo.js